/**
 * Created by tong on 2018/3/3.
 */
import {config, request, objectSerial} from 'Utils';

/*库存查询列表接口*/
export function list(param) {
    return request(`${config.server}/api/v1/dms/tgStock/data`, {
        method: 'post',
        body: {...param},
    });
}

export function scheduleList(param) {
    return request(`${config.server}/api/v1/dms/tgStock/searchDeliveryTime`, {
        method: 'post',
        body: {...param},
    });
}

export function scheduleListByDesc(param) {
    return request(`${config.server}/api/v1/dms/tgStock/searchDeliveryTimeByDesc`, {
        method: 'post',
        body: {...param},
    });
}

/*仓库类型筛选接口*/
export function stockScreening(param) {
    return request(`${config.server}/api/v1/dms/tgStock/orgStock`);
}

/*物料类别筛选接口*/
export function materialScreening(param) {
    return request(`${config.server}/api/v1/dms/tgStock/objType${objectSerial(param)}`);
}

/*库存警告筛选接口*/
export function materialScreening2(param) {
    return request(`${config.server}/api/v1/dms/tgStock/objType${objectSerial(param)}`);
}




// WEBPACK FOOTER //
// ./src/service/inventoryQuery/index.js